import React from "react";
import { data } from "../data";

// single feature component
const Feature = ({ icon, title, desc }) => {
	return (
		<div className="feature mt-8">
			<span className="icon fs-5 inline-flex align-center space-center px-3 py-3 mb-2">
				<i className={icon}></i>
			</span>
			<h3 className="feature-title fs-6 my-3">{title}</h3>
			<p className="feature-desc karla">{desc}</p>
		</div>
	);
};

// all features component
const Features = () => {
	return (
		<>
			<section className="features py-8 text-center dm">
				<div className="container">
					<h2 className="title">We’re different</h2>
					{data.map((item, key) => {
						return <Feature key={key} {...item} />;
					})}
				</div>
				<div className="clearfix"></div>
			</section>
		</>
	);
};

export default Features;
